import { getConsentSnapshot } from '@/contexts/consent/store';

export function hasDatadogConsent(): boolean {
    return getConsentSnapshot().analyticsAllowed;
}
